import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import Button from "@components/button/Button";
import useCookie from "@hooks/useCookie";
import useTranslations from "@hooks/useTranslations";
const CookieBanner = ({ defaultCookieValue }) => {
    const { setCookie, getCookie, removeCookie, myDocument, myWindow } = useCookie();
    const { t } = useTranslations();
    const [showBanner, setShowBanner] = useState(false);
    const cookieLevels = useRef({
        accept: "200",
        decline: defaultCookieValue
    });
    const acceptedCookie = "cookie-accepted";
    useEffect(() => {
        if (myDocument) {
            const noCookie = !getCookie(acceptedCookie);
            noCookie && setCookie("CMSCookieLevel", cookieLevels.current.decline, 365);
            setShowBanner(noCookie ? true : false);
        }
    }, [myDocument]);
    useEffect(() => {
        if (myWindow) {
            myWindow.resetCookieConsent = () => {
                removeCookie(acceptedCookie);
                myWindow.location.reload();
            };
        }
    }, [myWindow]);
    const handleButtons = (ev, type) => {
        ev.preventDefault();
        const value = cookieLevels.current[type];
        if (value !== undefined) {
            setCookie("CMSCookieLevel", value, 365);
            setCookie(acceptedCookie, "true", 365);
            setShowBanner(false);
        }
    };
    return showBanner ? (_jsx("div", { className: "cookie-banner", children: _jsxs("div", { className: "section-container", children: [_jsx("p", { className: "cookie-banner__description", dangerouslySetInnerHTML: { __html: t("BDO.LiveSite.CookieBanner.Description") } }), _jsxs("div", { className: "cookie-banner__footer", children: [_jsx(Button, { className: "mb-4 sm:mb-0", type: "primary", link: "!#", title: t("BDO.LiveSite.CookieBanner.Accept"), onClick: (ev) => handleButtons(ev, "accept") }), _jsx(Button, { className: "rtl:ml-0 sm:ml-4 rtl:sm:mr-4", type: "primary", link: "!#", title: t("BDO.LiveSite.CookieBanner.Decline"), onClick: (ev) => handleButtons(ev, "decline") })] })] }) })) : null;
};
export default CookieBanner;
